import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface AdminRouteProps {
    children: React.ReactNode;
}

/**
 * Componente de proteção de rota para páginas administrativas.
 * Redireciona usuários não-admin para a página inicial.
 */
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const { user, profile, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark">
                <span className="material-symbols-outlined text-4xl text-primary animate-spin">sync</span>
            </div>
        );
    }

    // Redireciona se não estiver autenticado ou não for admin
    if (!user || profile?.role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default AdminRoute;
